import { setLoading, setGlobalMessage } from '../../app';
import { ALERT_SEVERITY, ERROR_MESSAGES, GLOBAL_VALUES } from 'eebac/constants';
import { Catch } from '../../api_exception';

const BASE_PATH = "VENDOR_APPLIED_POSTS";

export const loadAppliedPosts = (rowsPerPage = null, page = null, clearExisting = true, resetFilters = false) =>
    (dispatch, getState, client) => {

        let state = getState().VENDOR_APPLIED_POSTS;
        let filters = [];

        if (!resetFilters) {
            if (state.state) {
                filters.push({ name: "state", values: [state.state] });
            }

            if (state.city && Array.isArray(state.city) && state.city.length > 0) {
                filters.push({ name: "city", values: state.city });
            }

            if (state.firmType && Array.isArray(state.firmType) && state.firmType.length > 0) {
                filters.push({ name: "firmType", values: state.firmType });
            }

            if (state.workType && Array.isArray(state.workType) && state.workType.length > 0) {
                filters.push({ name: "workType", values: state.workType });
            }

            if (state.status) {
                filters.push({ name: "status", values: [state.status] });
            }
        }

        let apiData = {
            itemsCount: state.rowsPerPage,
            currentPage: state.page + 1
        }

        if (filters.length > 0) {
            apiData.filters = filters;
        }

        if (rowsPerPage) {
            apiData.itemsCount = rowsPerPage;
        }

        if (page !== null) {
            apiData.currentPage = page + 1;
        }

        if (clearExisting) {
            dispatch(setPostsData([], 0, apiData.itemsCount, 0));
        }

        dispatch(setLoading(true));
        dispatch(isLoadingRecords(true));

        client.post('/vendor/posts/applied', apiData).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.posts) {
                    dispatch(setPostsData(result.data.posts,
                        (result.currentPage - 1), result.itemsCount, result.totalCount));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
                dispatch(isLoadingRecords(false));
            }).catch(error => {
                dispatch(isLoadingRecords(false));
                Catch(error, dispatch);
            });
    }

export const unApplyPost = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.get(`/vendor/post/unapply/${id}`).
            then(res => res.data).then(result => {
                if (result.isSuccess) {
                    dispatch(setGlobalMessage(result.successMessage,
                        ALERT_SEVERITY.SUCCESS));
                    dispatch(loadAppliedPosts());
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const SET_POSTS_DATA = `${BASE_PATH}/SET_POSTS_DATA`;
export const SET_FILTERS_DATA = `${BASE_PATH}/SET_FILTERS_DATA`;
export const SET_LOADING_RECORDS = `${BASE_PATH}/SET_LOADING_RECORDS`;

export const setPostsData = (posts, page, rowsPerPage, totalRows) => ({
    type: SET_POSTS_DATA,
    posts,
    page,
    rowsPerPage,
    totalRows
});

export const setFiltersData = (data) => ({
    type: SET_FILTERS_DATA,
    data
});

export const isLoadingRecords = (isLoadingRecords) => ({
    type: SET_LOADING_RECORDS,
    isLoadingRecords
});

const initialState = {
    posts: [],
    page: 0,
    rowsPerPage: GLOBAL_VALUES.DEFAULT_ROWS_PER_PAGE,
    totalRows: 0,

    state: '',
    city: [],
    firmType: [],
    workType: [],

    stateError: '',
    cityError: '',
    firmTypeError: '',
    workTypeError: '',
    isLoadingRecords: false
}

export default function reducer(state = { ...initialState }, action) {
    let newState = null;
    switch (action.type) {
        case SET_POSTS_DATA:
            newState = {
                ...state,
                posts: [...action.posts],
                page: action.page,
                rowsPerPage: action.rowsPerPage,
                totalRows: action.totalRows
            };
            return newState;
        case SET_FILTERS_DATA:
            newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case SET_LOADING_RECORDS:
            return {
                ...state,
                isLoadingRecords: action.isLoadingRecords
            }
    }

    return state;
}